export default{
  titleKey:'data-display',
  children:[
    {
      titleKey:'text-view',
      meta:{
        name:'TextView',
      }
    },
    {
      titleKey:'day-view',
      meta:{
        name:'DayView',
      }
    },
    {
      titleKey:'enum-view',
      meta:{
        name:'EnumView',
      }
    },
    {
      titleKey:'media-view',
      meta:{
        name:'MediaView',
      }
    },
    {
      titleKey:'loop-panel',
      meta:{
        name:'LoopPanel',
      }
    },
    {
      titleKey:'jsx-parser',
      meta:{
        name:'JsxTemplateParser',
      }
    },
  ]
}